import React from 'react'
import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn
} from 'material-ui/Table'
import * as MabnaButton from '../Button/Button'
import { translateProfileFields, PersianDate, Price } from '../../../helpers/utility'
import { connect } from 'react-redux'

const styles = {
  table: {
    width: '100%',
    fontFamily: 'IranYekanRegular',
    direction: 'ltr'
  },
  tableHeaderColumn: {
    textAlign: 'center',
    direction: 'rtl'
  },
  tableRowColumn: {
    textAlign: 'center',
    direction: 'rtl'
  }
}

const isPendingOrder = orderStatus => Boolean(orderStatus === 'pending')

const getOrderStatusColumn = orderStatus => {
  if (isPendingOrder(orderStatus)) {
    return <MabnaButton.Primary>پرداخت</MabnaButton.Primary>
  } else {
    return translateProfileFields(orderStatus)
  }
}

const isOrderType = type => order => order.service.type === type

const getActionColumn = order => {
  const isOrderEvent = isOrderType('event')

  if (isPendingOrder(order.order_status)) {
    return (
      <MabnaButton.Primary outline>
        لغو سفارش
      </MabnaButton.Primary>
    )
  } else {
    // if (isOrderEvent(order)) {
    return (
      <MabnaButton.Primary outline>
        دریافت رسید
      </MabnaButton.Primary>
    )
    // } else {
    //   return '-'
    // }
  }
}

const OrdersList = ({ result, orders, onCellClick, greaterThan }) => (
  <div className="manager-pages">
    <Table
      style={styles.table}
      selectable={false}
      multiSelectable={false}
      onCellClick={onCellClick}
    >
      <TableHeader
        displaySelectAll={false}
        enableSelectAll={false}
        adjustForCheckbox={false}
      >
        <TableRow>
          {greaterThan.extraSmall && (
            <TableHeaderColumn style={styles.tableHeaderColumn}>عملیات</TableHeaderColumn>
          )}

          {greaterThan.extraSmall && (
            <TableHeaderColumn style={styles.tableHeaderColumn}>
              وضعیت سفارش
            </TableHeaderColumn>
          )}

          {greaterThan.small && (
            <TableHeaderColumn style={styles.tableHeaderColumn}>
              تاریخ سفارش
            </TableHeaderColumn>
          )}

          {greaterThan.extraSmall && (
            <TableHeaderColumn style={styles.tableHeaderColumn}>
              مبلغ سفارش (تومان)
            </TableHeaderColumn>
          )}

          <TableHeaderColumn style={styles.tableHeaderColumn}>
            مبلغ پرداخت شده
          </TableHeaderColumn>

          <TableHeaderColumn style={styles.tableHeaderColumn}>
            سرویس خریداری شده
          </TableHeaderColumn>
        </TableRow>
      </TableHeader>
      <TableBody showRowHover={false} displayRowCheckbox={false}>
        {result.map((orderId, i) => {
          const order = orders[orderId]

          const service = order.service

          return (
            <TableRow
              hoverable={true}
              selectable={true}
              key={order.id}
              className={order.order_status}
            >
              {greaterThan.small && (
                <TableRowColumn style={styles.tableRowColumn}>
                  {getActionColumn(order)}
                </TableRowColumn>
              )}

              <TableRowColumn style={styles.tableRowColumn}>
                {getOrderStatusColumn(order.order_status)}
              </TableRowColumn>

              {greaterThan.small && (
                <TableRowColumn style={styles.tableRowColumn}>
                  <PersianDate>{order.created_at}</PersianDate>
                </TableRowColumn>
              )}

              {greaterThan.extraSmall && (
                <TableRowColumn style={styles.tableRowColumn}>
                  <Price>{order.amount}</Price>
                  {!!order.amount && !!order.coins_cost && ' یا '}
                  {!!order.coins_cost && <span>{order.coins_cost} سکه</span>}
                </TableRowColumn>
              )}

              {greaterThan.extraSmall && (
                <TableRowColumn style={styles.tableRowColumn}>
                  {order.paid !== 0
                    ? <Price>{order.paid}</Price>
                    : (order.paid_coins !== 0 ?  <span>{order.paid_coins} سکه</span>  : '-')
                  }
                </TableRowColumn>
              )}

              <TableRowColumn style={styles.tableRowColumn}>
                {service.title}
              </TableRowColumn>
            </TableRow>
          )
        })}
      </TableBody>
    </Table>
  </div>
)

export default connect(state => ({
  greaterThan: state.browser.greaterThan
}))(OrdersList)



// WEBPACK FOOTER //
// ./src/components/common/orders/OrdersList.js